<template>
  <div>
    <div class="db-3 screen">
      <div class="flex-row">
        <div class="frame-1750">
          <div class="text-54 inter-normal-black-20px">
            Package summary and Complete Payment
          </div>
          <p class="text-55 inter-normal-storm-gray-14px">
            Understand the biosensors behavior in few steps. One step away
            exploring the biosensor data in whole different way.
          </p>
        </div>
      </div>
      <div class="frame-1748">
        <div class="frame-1747">
          <div class="frame-1746-1">
            <div class="number-1 inter-normal-white-14px">
              1
            </div>
          </div>
          <div class="customise-plan inter-normal-black-16px">
            Customise plan
          </div>
        </div>
        <svg
          width="40"
          class="line"
          height="1"
          viewBox="0 0 40 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="0.5"
            y1="0.5"
            x2="39.5"
            y2="0.5"
            stroke="#E8E8E8"
            stroke-linecap="round"
            stroke-dasharray="2 2"
          />
        </svg>

        <div class="frame-1748-1">
          <div class="frame-1746">
            <div class="number inter-normal-white-14px">
              2
            </div>
          </div>
          <div class="payment-information inter-normal-black-16px">
            Payment information
          </div>
        </div>
        <svg
          width="40"
          class="line"
          height="1"
          viewBox="0 0 40 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="0.5"
            y1="0.5"
            x2="39.5"
            y2="0.5"
            stroke="#E8E8E8"
            stroke-linecap="round"
            stroke-dasharray="2 2"
          />
        </svg>
        <div class="frame-1749">
          <div class="frame-1746">
            <div class="number inter-normal-white-14px">
              3
            </div>
          </div>
          <div class="text-53 inter-normal-black-16px">
            Review and make payment
          </div>
        </div>
      </div>
      <div class="group-1987">
        <div class="group-1986">
          <div class="frame-1755">
            <div class="business-plan-1">
              {{ userbasedplaninfo.metadata.name }}
            </div>
          </div>
          <svg
            class="line-10"
            width="465"
            height="1"
            viewBox="0 0 465 1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              y1="0.5"
              x2="465"
              y2="0.5"
              stroke="#CBD5E1"
            />
          </svg>

          <div class="frame-1756">
            <div class="frame-1754">
              <div class="frame-1753">
                <div class="business-plan inter-normal-black-20px">
                  {{ userbasedplaninfo.metadata.name }}
                </div>
                <p class="text-5-1 inter-normal-storm-gray-14px">
                  Strive towards data goal with djuli. We value your inputs
                  helping you to understand sensors response more closely.
                </p>
              </div>
              <div class="price inter-semi-bold-mirage-19px">
                €{{ userbasedplaninfo.amount/100 }}
              </div>
            </div>
          </div>
          <svg
            width="465"
            height="1"
            viewBox="0 0 465 1"
            class="line-11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              y1="0.5"
              x2="465"
              y2="0.5"
              stroke="#E2E8F0"
            />
          </svg>

          <div class="flex-row-1">
            <div class="subtotal inter-normal-black-20px">
              Subtotal
            </div>
            <div class="price-1">
              €{{ userbasedplaninfo.amount/100 }}
            </div>
          </div>
        </div>

        <div
          class="buttonsubscribe-1"
          @click="$emit('submitPayment')"
        >
          <div class="complete-purchase roboto-medium-white-18px">
            Complete Purchase
          </div>
        </div>
      </div>
      <p class="text-56">
        <span
          class="inter-normal-storm-gray-14px"
        >We gurantee your satisfaction with djuli. If you are not satisfied with our services or prices, you can always </span>
        <router-link to="/pricing/details">
          <span
            class="inter-normal-mountain-meadow-14px"
          >Cancel Subscription</span>
        </router-link>
        <span
          class="inter-normal-storm-gray-14px"
        >  Please read the terms and conditions before purchasing the djuli services by clicking on<br></span>
        <router-link to="/terms-conditions">
          <span class="inter-normal-mountain-meadow-14px">Terms & Policies</span>
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';


export default {
  props: ['finalConfirmationCardInput'],
  emits: ['submitPayment'],
  
  data() {
    return {
      amount: '',
      planid: '',
    };
  },

  computed: {
    ...mapGetters({
      userbasedplaninfo: 'subscription/userBasedPlanInfo',
    }),
  },
};
</script>

<style scoped>
.db-3 {
  align-items: center;
  background-color: var(--white);
  display: flex;
  flex-direction: column;
  
 
}

.db-3 .headerdb-regular-option-1 {
  align-items: center;
  background-color: var(--white);
  box-shadow: 0px 1px 0px #e2e8f0;
  display: flex;
  height: 60px;
  min-width: 1440px;
  padding: 0 40px;
}

.db-3 .frame-1737 {
  align-items: flex-start;
  display: flex;
  min-width: 327px;
}

.db-3 .big-1 {
  height: 32px;
  object-fit: cover;
  width: 70px;
}

.db-3 .frame-1729 {
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: flex-end;
  margin-left: 33px;
  min-width: 224px;
  padding: 0 6px;
}

.db-3 .dashboard {
  letter-spacing: 0;
  line-height: 24px;
  min-height: 24px;
  min-width: 87px;
  white-space: nowrap;
}

.db-3 .terminal {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 54px;
  min-height: 24px;
  min-width: 69px;
  white-space: nowrap;
}

.db-3 .icon {
  align-items: flex-end;
  display: flex;
  height: 20px;
  margin-left: 611px;
  padding: 0.8px;
  width: 20px;
}

.db-3 .overlap-group {
  height: 18px;
  margin-left: 1px;
  position: relative;
  width: 18px;
}

.db-3 .vector {
  height: 16px;
  left: 0;
  position: absolute;
  top: 0;
  width: 16px;
}

.db-3 .vector-1 {
  height: 7px;
  left: 11px;
  position: absolute;
  top: 11px;
  width: 7px;
}

.db-3 .frame-1733 {
  align-items: center;
  display: flex;
  margin-left: 23px;
  min-width: 378px;
}

.db-3 .frame-1731 {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 33px;
  justify-content: flex-end;
  min-width: 71px;
  padding: 0 6px;
}

.db-3 .help {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 8px;
  min-height: 17px;
  min-width: 33px;
  white-space: nowrap;
}

.db-3 .frame-1736 {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 36px;
  justify-content: flex-end;
  margin-left: 24px;
  min-width: 135px;
}

.db-3 .ellipse-4 {
  height: 32px;
  object-fit: cover;
  width: 32px;
}

.db-3 .frame-1734 {
  align-items: center;
  display: flex;
  height: 33px;
  margin-left: 2px;
  min-width: 99px;
  padding: 0 8px;
}

.db-3 .name {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 65px;
  white-space: nowrap;
}

.db-3 .polygon-3 {
  height: 8px;
  margin-bottom: 0;
  margin-left: 7px;
  width: 10px;
}

.db-3 .frame-1732 {
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  height: 35px;
  justify-content: flex-end;
  margin-left: 24px;
  min-width: 124px;
  padding: 8px 6px;
}

.db-3 .iconsnotificationinactive {
  align-items: flex-start;
  display: flex;
  height: 19px;
  min-width: 16px;
}

.db-3 .ellipse-3 {
  background-color: var(--djuli-secondary-color);
  border-radius: 3.5px;
  height: 7px;
  width: 7px;
}

.db-3 .notifications {
  align-self: center;
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 8px;
  min-height: 17px;
  min-width: 86px;
  white-space: nowrap;
}

.db-3 .flex-row {
  align-items: flex-start;
  /* align-self: flex-start; */
  /* display: flex; */
  height: 114px;
  /* margin-left: 154px; */
  /* margin-top: 24px; */
  /* min-width: 755px; */
  
  margin-top: 4rem;
}

.db-3 .frame-1739 {
  align-items: flex-start;
  display: flex;
  height: 20px;
  min-width: 192px;
}

.db-3 .item {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 42px;
  white-space: nowrap;
}

.db-3 .text-5 {
  letter-spacing: 0;
  line-height: 20px;
  margin-left: 2px;
  min-height: 20px;
  min-width: 7px;
  white-space: nowrap;
}

.db-3 .item-1 {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 2px;
  min-height: 17px;
  min-width: 45px;
  white-space: nowrap;
}

.db-3 .item-2 {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 2px;
  min-height: 17px;
  white-space: nowrap;
}

.db-3 .group-1989 {
  cursor: pointer;
}

.db-3 .overlap-group-2 {
  align-items: flex-start;
  background-color: var(--white);
  border-radius: 4px;
  display: flex;
  height: 48px;
  min-width: 121px;
  padding: 17.5px 41.5px;
}

.db-3 .place {
  letter-spacing: 0;
  min-height: 12px;
  text-align: center;
  width: 38px;
}

.db-3 .text-54 {
  letter-spacing: 0;
  line-height: 28px;
  margin-left: 2px;
  min-height: 28px;
  min-width: 379px;
  text-align: center;
  white-space: nowrap;
}

.db-3 .text-55 {
    /* letter-spacing: 0; */
    /* line-height: 17px; */
    /* margin-left: 2px; */
    /* margin-top: 8px; */
    /* justify-content: center; */
    display: 34px;
    text-align: center;
    width: 357px;
    /* display: flex; */
    margin: auto;
    padding: 0.75rem 0rem
}

.db-3 .frame-1748 {
  align-items: center;
  display: flex;
  height: 48px;
  /* margin-left: 1px; */
  margin-top: 24px;
  /* min-width: 835px; */
  /* padding: 0 8px;*/
}

.db-3 .frame-1747 {
  align-items: center;
  display: flex;
  min-width: 157px;
}

.db-3 .frame-1746-1 {
  align-items: flex-end;
  background-color: var(--djuli-tertiary-color);
  border-radius: 16px;
  display: flex;
  height: 32px;
  justify-content: flex-end;
  min-width: 32px;
  padding: 7px 10px;
}

.db-3 .number-1 {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 9px;
  white-space: nowrap;
}

.db-3 .customise-plan {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 8px;
  min-height: 24px;
  min-width: 119px;
  white-space: nowrap;
}

.db-3 .line {
  height: 1px;
  margin-left: 40px;
  width: 40px;
}

.db-3 .frame-1748-1 {
  align-items: center;
  display: flex;
  margin-left: 40px;
  min-width: 197px;
}

.db-3 .frame-1746 {
  align-items: flex-end;
  background-color: var(--djuli-tertiary-color);
  border-radius: 16px;
  display: flex;
  height: 32px;
  justify-content: flex-end;
  min-width: 32px;
  padding: 7px 8px;
}

.db-3 .number {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 11px;
  white-space: nowrap;
}

.db-3 .payment-information {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 8px;
  min-height: 24px;
  min-width: 159px;
  white-space: nowrap;
}

.db-3 .frame-1749 {
  align-items: center;
  display: flex;
  margin-left: 40px;
  min-width: 225px;
}

.db-3 .text-53 {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 8px;
  min-height: 24px;
  min-width: 187px;
  white-space: nowrap;
}

.db-3 .group-1987 {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 82px;
  width: 480px;
}

.db-3 .group-1986 {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-left: 2px;
  width: 482px;
}

.db-3 .frame-1755 {
  align-items: center;
  display: flex;
  margin-right: 2px;
  min-width: 464px;
}

.db-3 .business-plan-1 {
  color: var(--black);
  font-family: var(--font-family-inter);
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.46px;
  line-height: 28px;
  min-height: 28px;
  min-width: 153px;
  white-space: nowrap;
}

.db-3 .cta-plate {
  align-items: flex-start;
  background-color: var(--white);
  border-radius: 12px;
  display: flex;
  height: 66px;
  margin-left: 69px;
  min-width: 242px;
  padding: 4.5px;
}

.db-3 .buttonsubscribe {
  align-items: flex-end;
  background-color: var(--djuli-primary-color);
  border-radius: 8px;
  box-shadow: 0px 16px 24px #0000001f;
  display: flex;
  height: 55px;
  justify-content: flex-end;
  min-width: 120px;
  padding: 19px 25px;
}

.db-3 .line-10 {
  height: 1px;
  margin-right: 1px;
  margin-top: 30px;
  width: 465px;
}

.db-3 .frame-1756 {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-right: 2px;
  margin-top: 23px;
  padding: 8px 0;
  width: 480px;
}

.db-3 .frame-1754 {
  align-items: center;
  display: flex;
  height: 87px;
  min-width: 464px;
}

.db-3 .frame-1753 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  min-height: 87px;
  width: 237px;
}

.db-3 .business-plan {
  letter-spacing: 0;
  line-height: 28px;
  min-height: 28px;
  white-space: nowrap;
}

.db-3 .text-5-1 {
  letter-spacing: 0;
  line-height: 17px;
  margin-top: 8px;
  min-height: 51px;
  width: 239px;
}

.db-3 .price {
  letter-spacing: -0.38px;
  line-height: 23px;
  margin-left: 173px;
  min-height: 23px;
  min-width: 56px;
  white-space: nowrap;
}

.db-3 .frame-1756-1 {
  align-items: center;
  display: flex;
  height: 87px;
  margin-top: 24px;
  min-width: 464px;
}

.db-3 .line-11 {
  height: 1px;
  margin-right: 1px;
  margin-top: 23px;
  width: 465px;
}

.db-3 .flex-row-1 {
  align-items: flex-start;
  display: flex;
  height: 28px;
  margin-left: 1px;
  margin-top: 28px;
  min-width: 467px;
}

.db-3 .subtotal {
  letter-spacing: 0;
  line-height: 28px;
  min-height: 28px;
  min-width: 82px;
  white-space: nowrap;
}

.db-3 .price-1 {
  color: var(--mirage);
  font-family: var(--font-family-inter);
  font-size: 23px;
  font-weight: 600;
  letter-spacing: -0.46px;
  line-height: 28px;
  margin-left: 308px;
  min-height: 28px;
  white-space: nowrap;
}

.db-3 .buttonsubscribe-1 {
  align-items: center;
  background-color: var(--djuli-primary-color);
  border-radius: 8px;
  box-shadow: 0px 16px 24px #0000001f;
  cursor: pointer;
  display: flex;
  height: 69px;
  justify-content: flex-end;
  margin-left: 1px;
  margin-top: 39px;
  min-width: 255px;
  padding: 0 47px;
}

.db-3 .complete-purchase {
  letter-spacing: 0;
  min-height: 21px;
  min-width: 159px;
  text-align: center;
}

.db-3 .text-56 {
  color: transparent;
  font-family: var(--font-family-inter);
  font-size: var(--font-size-s);
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 2px;
  margin-top: 58px;
  min-height: 85px;
  text-align: center;
  width: 522px;
}
</style>

